import { ShiftCloseoutPaymentTotalInput } from '@/features/graphql/generated/graphql'
import { FormOutput } from '@/features/shiftCloseouts/form/types'
import { ShiftCloseoutPaymentMethod } from '@/features/shiftCloseouts/types'
import invariant from 'tiny-invariant'

export const transformReportedPaymentTotals = (
    paymentMethods: ShiftCloseoutPaymentMethod[],
    form: FormOutput
): ShiftCloseoutPaymentTotalInput[] =>
    paymentMethods.flatMap(({ identifier, mode, paymentType }) => {
        if (mode === 'automatic' || !paymentType) return []

        const amount = form.actualAmounts[paymentType]

        invariant(amount !== undefined, `Missing reported payment amount: ${identifier}`)

        return [{ amount, paymentType }]
    })
